import { render, staticRenderFns } from "./IndexAnalisisSampel.vue?vue&type=template&id=560878f2&scoped=true&"
import script from "./IndexAnalisisSampel.vue?vue&type=script&lang=js&"
export * from "./IndexAnalisisSampel.vue?vue&type=script&lang=js&"
import style0 from "./IndexAnalisisSampel.vue?vue&type=style&index=0&id=560878f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560878f2",
  null
  
)

export default component.exports